/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreBulkOperationResultDto } from '../models/core-bulk-operation-result-dto';
import { CoreProjectSubtaskResponseDto } from '../models/core-project-subtask-response-dto';
import { projectSubtasksControllerAddRejection } from '../fn/project-subtasks/project-subtasks-controller-add-rejection';
import { ProjectSubtasksControllerAddRejection$Params } from '../fn/project-subtasks/project-subtasks-controller-add-rejection';
import { projectSubtasksControllerAssignSubtask } from '../fn/project-subtasks/project-subtasks-controller-assign-subtask';
import { ProjectSubtasksControllerAssignSubtask$Params } from '../fn/project-subtasks/project-subtasks-controller-assign-subtask';
import { projectSubtasksControllerBulkOperation } from '../fn/project-subtasks/project-subtasks-controller-bulk-operation';
import { ProjectSubtasksControllerBulkOperation$Params } from '../fn/project-subtasks/project-subtasks-controller-bulk-operation';
import { projectSubtasksControllerCreate } from '../fn/project-subtasks/project-subtasks-controller-create';
import { ProjectSubtasksControllerCreate$Params } from '../fn/project-subtasks/project-subtasks-controller-create';
import { projectSubtasksControllerDelete } from '../fn/project-subtasks/project-subtasks-controller-delete';
import { ProjectSubtasksControllerDelete$Params } from '../fn/project-subtasks/project-subtasks-controller-delete';
import { projectSubtasksControllerDeleteByTaskId } from '../fn/project-subtasks/project-subtasks-controller-delete-by-task-id';
import { ProjectSubtasksControllerDeleteByTaskId$Params } from '../fn/project-subtasks/project-subtasks-controller-delete-by-task-id';
import { projectSubtasksControllerFindAllByTenant } from '../fn/project-subtasks/project-subtasks-controller-find-all-by-tenant';
import { ProjectSubtasksControllerFindAllByTenant$Params } from '../fn/project-subtasks/project-subtasks-controller-find-all-by-tenant';
import { projectSubtasksControllerFindApprovals } from '../fn/project-subtasks/project-subtasks-controller-find-approvals';
import { ProjectSubtasksControllerFindApprovals$Params } from '../fn/project-subtasks/project-subtasks-controller-find-approvals';
import { projectSubtasksControllerFindByApproverId } from '../fn/project-subtasks/project-subtasks-controller-find-by-approver-id';
import { ProjectSubtasksControllerFindByApproverId$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-approver-id';
import { projectSubtasksControllerFindByAssignedTo } from '../fn/project-subtasks/project-subtasks-controller-find-by-assigned-to';
import { ProjectSubtasksControllerFindByAssignedTo$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-assigned-to';
import { projectSubtasksControllerFindByProjectAndDate } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-and-date';
import { ProjectSubtasksControllerFindByProjectAndDate$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-and-date';
import { projectSubtasksControllerFindByProjectId } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-id';
import { ProjectSubtasksControllerFindByProjectId$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-id';
import { projectSubtasksControllerFindByProjectManager } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-manager';
import { ProjectSubtasksControllerFindByProjectManager$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-project-manager';
import { projectSubtasksControllerFindByTaskId } from '../fn/project-subtasks/project-subtasks-controller-find-by-task-id';
import { ProjectSubtasksControllerFindByTaskId$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-task-id';
import { projectSubtasksControllerFindByValidatorId } from '../fn/project-subtasks/project-subtasks-controller-find-by-validator-id';
import { ProjectSubtasksControllerFindByValidatorId$Params } from '../fn/project-subtasks/project-subtasks-controller-find-by-validator-id';
import { projectSubtasksControllerFindOne } from '../fn/project-subtasks/project-subtasks-controller-find-one';
import { ProjectSubtasksControllerFindOne$Params } from '../fn/project-subtasks/project-subtasks-controller-find-one';
import { projectSubtasksControllerGetSuggestion } from '../fn/project-subtasks/project-subtasks-controller-get-suggestion';
import { ProjectSubtasksControllerGetSuggestion$Params } from '../fn/project-subtasks/project-subtasks-controller-get-suggestion';
import { projectSubtasksControllerGetWorkloadData } from '../fn/project-subtasks/project-subtasks-controller-get-workload-data';
import { ProjectSubtasksControllerGetWorkloadData$Params } from '../fn/project-subtasks/project-subtasks-controller-get-workload-data';
import { projectSubtasksControllerSoftDeleteAttachment } from '../fn/project-subtasks/project-subtasks-controller-soft-delete-attachment';
import { ProjectSubtasksControllerSoftDeleteAttachment$Params } from '../fn/project-subtasks/project-subtasks-controller-soft-delete-attachment';
import { projectSubtasksControllerUpdate } from '../fn/project-subtasks/project-subtasks-controller-update';
import { ProjectSubtasksControllerUpdate$Params } from '../fn/project-subtasks/project-subtasks-controller-update';
import { projectSubtasksControllerUpdateByProjectId } from '../fn/project-subtasks/project-subtasks-controller-update-by-project-id';
import { ProjectSubtasksControllerUpdateByProjectId$Params } from '../fn/project-subtasks/project-subtasks-controller-update-by-project-id';
import { projectSubtasksControllerUpdateByTaskId } from '../fn/project-subtasks/project-subtasks-controller-update-by-task-id';
import { ProjectSubtasksControllerUpdateByTaskId$Params } from '../fn/project-subtasks/project-subtasks-controller-update-by-task-id';
import { CoreProjectSubtaskSuggestionResponseDto } from '../models/core-project-subtask-suggestion-response-dto';
import { CoreWorkloadSubtaskDto } from '../models/core-workload-subtask-dto';

@Injectable({ providedIn: 'root' })
export class CoreProjectSubtasksService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectSubtasksControllerFindAllByTenant()` */
  static readonly ProjectSubtasksControllerFindAllByTenantPath = '/o2-core/project-subtasks/{tenant}';

  /**
   * Retrieve all project subtasks by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindAllByTenant$Response(params: ProjectSubtasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindAllByTenant(params: ProjectSubtasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerCreate()` */
  static readonly ProjectSubtasksControllerCreatePath = '/o2-core/project-subtasks/{tenant}';

  /**
   * Create a new project subtask.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerCreate$Response(params: ProjectSubtasksControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new project subtask.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerCreate(params: ProjectSubtasksControllerCreate$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindOne()` */
  static readonly ProjectSubtasksControllerFindOnePath = '/o2-core/project-subtasks/{tenant}/{id}';

  /**
   * Retrieve a project subtask by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindOne$Response(params: ProjectSubtasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a project subtask by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindOne(params: ProjectSubtasksControllerFindOne$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerDelete()` */
  static readonly ProjectSubtasksControllerDeletePath = '/o2-core/project-subtasks/{tenant}/{id}';

  /**
   * Delete a project subtask by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerDelete$Response(params: ProjectSubtasksControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a project subtask by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerDelete(params: ProjectSubtasksControllerDelete$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerUpdate()` */
  static readonly ProjectSubtasksControllerUpdatePath = '/o2-core/project-subtasks/{tenant}/{id}';

  /**
   * Update a project subtask by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdate$Response(params: ProjectSubtasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a project subtask by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdate(params: ProjectSubtasksControllerUpdate$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerUpdateByProjectId()` */
  static readonly ProjectSubtasksControllerUpdateByProjectIdPath = '/o2-core/project-subtasks/{tenant}/project/{projectId}';

  /**
   * Update all project subtasks by project ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerUpdateByProjectId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdateByProjectId$Response(params: ProjectSubtasksControllerUpdateByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = projectSubtasksControllerUpdateByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update all project subtasks by project ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerUpdateByProjectId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdateByProjectId(params: ProjectSubtasksControllerUpdateByProjectId$Params, context?: HttpContext): Observable<void> {
    const resp = this.projectSubtasksControllerUpdateByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerDeleteByTaskId()` */
  static readonly ProjectSubtasksControllerDeleteByTaskIdPath = '/o2-core/project-subtasks/{tenant}/task/{taskId}';

  /**
   * Delete all project subtasks by task ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerDeleteByTaskId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerDeleteByTaskId$Response(params: ProjectSubtasksControllerDeleteByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = projectSubtasksControllerDeleteByTaskId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete all project subtasks by task ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerDeleteByTaskId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerDeleteByTaskId(params: ProjectSubtasksControllerDeleteByTaskId$Params, context?: HttpContext): Observable<void> {
    const resp = this.projectSubtasksControllerDeleteByTaskId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerUpdateByTaskId()` */
  static readonly ProjectSubtasksControllerUpdateByTaskIdPath = '/o2-core/project-subtasks/{tenant}/task/{taskId}';

  /**
   * Update all project subtasks by task ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerUpdateByTaskId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdateByTaskId$Response(params: ProjectSubtasksControllerUpdateByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = projectSubtasksControllerUpdateByTaskId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update all project subtasks by task ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerUpdateByTaskId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerUpdateByTaskId(params: ProjectSubtasksControllerUpdateByTaskId$Params, context?: HttpContext): Observable<void> {
    const resp = this.projectSubtasksControllerUpdateByTaskId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerGetSuggestion()` */
  static readonly ProjectSubtasksControllerGetSuggestionPath = '/o2-core/project-subtasks/{tenant}/suggestion';

  /**
   * Get subtask code and name suggestion for a task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerGetSuggestion()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerGetSuggestion$Response(params: ProjectSubtasksControllerGetSuggestion$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskSuggestionResponseDto>> {
    const obs = projectSubtasksControllerGetSuggestion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get subtask code and name suggestion for a task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerGetSuggestion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerGetSuggestion(params: ProjectSubtasksControllerGetSuggestion$Params, context?: HttpContext): Observable<CoreProjectSubtaskSuggestionResponseDto> {
    const resp = this.projectSubtasksControllerGetSuggestion$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskSuggestionResponseDto>): CoreProjectSubtaskSuggestionResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindApprovals()` */
  static readonly ProjectSubtasksControllerFindApprovalsPath = '/o2-core/project-subtasks/{tenant}/approvals';

  /**
   * Retrieve all project subtasks for approvals.
   *
   * Returns subtasks with approval object. This includes both pending approvals (PENDING_APPROVAL status) and already approved subtasks. Optionally filter by approverId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindApprovals()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindApprovals$Response(params: ProjectSubtasksControllerFindApprovals$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindApprovals(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks for approvals.
   *
   * Returns subtasks with approval object. This includes both pending approvals (PENDING_APPROVAL status) and already approved subtasks. Optionally filter by approverId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindApprovals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindApprovals(params: ProjectSubtasksControllerFindApprovals$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindApprovals$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerGetWorkloadData()` */
  static readonly ProjectSubtasksControllerGetWorkloadDataPath = '/o2-core/project-subtasks/{tenant}/workload';

  /**
   * Retrieve assigned subtasks for workload analytics.
   *
   * Returns only assigned subtasks with minimal fields (assignment, budget, project) optimized for workload calculations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerGetWorkloadData()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerGetWorkloadData$Response(params: ProjectSubtasksControllerGetWorkloadData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreWorkloadSubtaskDto>>> {
    const obs = projectSubtasksControllerGetWorkloadData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve assigned subtasks for workload analytics.
   *
   * Returns only assigned subtasks with minimal fields (assignment, budget, project) optimized for workload calculations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerGetWorkloadData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerGetWorkloadData(params: ProjectSubtasksControllerGetWorkloadData$Params, context?: HttpContext): Observable<Array<CoreWorkloadSubtaskDto>> {
    const resp = this.projectSubtasksControllerGetWorkloadData$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreWorkloadSubtaskDto>>): Array<CoreWorkloadSubtaskDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByProjectId()` */
  static readonly ProjectSubtasksControllerFindByProjectIdPath = '/o2-core/project-subtasks/{tenant}/project/{projectId}/subtasks';

  /**
   * Retrieve all project subtasks for a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectId$Response(params: ProjectSubtasksControllerFindByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks for a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectId(params: ProjectSubtasksControllerFindByProjectId$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByTaskId()` */
  static readonly ProjectSubtasksControllerFindByTaskIdPath = '/o2-core/project-subtasks/{tenant}/task/{taskId}/subtasks';

  /**
   * Retrieve all project subtasks for a specific task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByTaskId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByTaskId$Response(params: ProjectSubtasksControllerFindByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByTaskId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks for a specific task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByTaskId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByTaskId(params: ProjectSubtasksControllerFindByTaskId$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByTaskId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByProjectAndDate()` */
  static readonly ProjectSubtasksControllerFindByProjectAndDatePath = '/o2-core/project-subtasks/{tenant}/project/{projectId}/by-date';

  /**
   * Retrieve all project subtasks for a specific project and date range (for sprint planning).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByProjectAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectAndDate$Response(params: ProjectSubtasksControllerFindByProjectAndDate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByProjectAndDate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks for a specific project and date range (for sprint planning).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByProjectAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectAndDate(params: ProjectSubtasksControllerFindByProjectAndDate$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByProjectAndDate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByAssignedTo()` */
  static readonly ProjectSubtasksControllerFindByAssignedToPath = '/o2-core/project-subtasks/{tenant}/assigned-to/{assignedTo}';

  /**
   * Retrieve all project subtasks assigned to a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByAssignedTo()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByAssignedTo$Response(params: ProjectSubtasksControllerFindByAssignedTo$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByAssignedTo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks assigned to a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByAssignedTo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByAssignedTo(params: ProjectSubtasksControllerFindByAssignedTo$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByAssignedTo$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByApproverId()` */
  static readonly ProjectSubtasksControllerFindByApproverIdPath = '/o2-core/project-subtasks/{tenant}/approver/{approverId}';

  /**
   * Retrieve all project subtasks where a specific user is the approver.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByApproverId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByApproverId$Response(params: ProjectSubtasksControllerFindByApproverId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByApproverId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks where a specific user is the approver.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByApproverId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByApproverId(params: ProjectSubtasksControllerFindByApproverId$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByApproverId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByValidatorId()` */
  static readonly ProjectSubtasksControllerFindByValidatorIdPath = '/o2-core/project-subtasks/{tenant}/validator/{validatorId}';

  /**
   * Retrieve all project subtasks where a specific user is the validator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByValidatorId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByValidatorId$Response(params: ProjectSubtasksControllerFindByValidatorId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByValidatorId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks where a specific user is the validator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByValidatorId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByValidatorId(params: ProjectSubtasksControllerFindByValidatorId$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByValidatorId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerFindByProjectManager()` */
  static readonly ProjectSubtasksControllerFindByProjectManagerPath = '/o2-core/project-subtasks/{tenant}/project-manager/{projectManagerId}';

  /**
   * Retrieve all project subtasks for projects managed by a specific project manager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerFindByProjectManager()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectManager$Response(params: ProjectSubtasksControllerFindByProjectManager$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
    const obs = projectSubtasksControllerFindByProjectManager(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project subtasks for projects managed by a specific project manager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerFindByProjectManager$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtasksControllerFindByProjectManager(params: ProjectSubtasksControllerFindByProjectManager$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskResponseDto>> {
    const resp = this.projectSubtasksControllerFindByProjectManager$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>): Array<CoreProjectSubtaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerAddRejection()` */
  static readonly ProjectSubtasksControllerAddRejectionPath = '/o2-core/project-subtasks/{tenant}/{id}/rejection';

  /**
   * Add a rejection to a subtask.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerAddRejection()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerAddRejection$Response(params: ProjectSubtasksControllerAddRejection$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerAddRejection(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a rejection to a subtask.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerAddRejection$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerAddRejection(params: ProjectSubtasksControllerAddRejection$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerAddRejection$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerBulkOperation()` */
  static readonly ProjectSubtasksControllerBulkOperationPath = '/o2-core/project-subtasks/{tenant}/operations/bulk';

  /**
   * Perform bulk operation (validate or approve).
   *
   * Unified endpoint that validates or approves multiple subtasks based on operation type. User ID is used as validatorId or approverId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerBulkOperation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerBulkOperation$Response(params: ProjectSubtasksControllerBulkOperation$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreBulkOperationResultDto>> {
    const obs = projectSubtasksControllerBulkOperation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Perform bulk operation (validate or approve).
   *
   * Unified endpoint that validates or approves multiple subtasks based on operation type. User ID is used as validatorId or approverId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerBulkOperation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerBulkOperation(params: ProjectSubtasksControllerBulkOperation$Params, context?: HttpContext): Observable<CoreBulkOperationResultDto> {
    const resp = this.projectSubtasksControllerBulkOperation$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreBulkOperationResultDto>): CoreBulkOperationResultDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerAssignSubtask()` */
  static readonly ProjectSubtasksControllerAssignSubtaskPath = '/o2-core/project-subtasks/{tenant}/{id}/assign';

  /**
   * Assign a subtask to a user.
   *
   * Assigns a subtask to a user with assignment dates. Estimated hours are calculated in the frontend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerAssignSubtask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerAssignSubtask$Response(params: ProjectSubtasksControllerAssignSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
    const obs = projectSubtasksControllerAssignSubtask(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Assign a subtask to a user.
   *
   * Assigns a subtask to a user with assignment dates. Estimated hours are calculated in the frontend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerAssignSubtask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerAssignSubtask(params: ProjectSubtasksControllerAssignSubtask$Params, context?: HttpContext): Observable<CoreProjectSubtaskResponseDto> {
    const resp = this.projectSubtasksControllerAssignSubtask$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>): CoreProjectSubtaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtasksControllerSoftDeleteAttachment()` */
  static readonly ProjectSubtasksControllerSoftDeleteAttachmentPath = '/o2-core/project-subtasks/{tenant}/subtasks/{subtaskId}/attachments';

  /**
   * Soft delete a subtask attachment.
   *
   * Marks an attachment as deleted without removing it from S3. Deleted attachments are hidden from responses. Operation is idempotent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtasksControllerSoftDeleteAttachment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerSoftDeleteAttachment$Response(params: ProjectSubtasksControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<{
'success'?: boolean;
}>> {
    const obs = projectSubtasksControllerSoftDeleteAttachment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Soft delete a subtask attachment.
   *
   * Marks an attachment as deleted without removing it from S3. Deleted attachments are hidden from responses. Operation is idempotent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtasksControllerSoftDeleteAttachment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtasksControllerSoftDeleteAttachment(params: ProjectSubtasksControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<{
'success'?: boolean;
}> {
    const resp = this.projectSubtasksControllerSoftDeleteAttachment$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<{
'success'?: boolean;
}>): {
'success'?: boolean;
} => r.body)
    );
  }

}
